import { motion } from 'framer-motion';
import type { IconType } from 'react-icons';

interface SkillBadgeProps {
  name: string;
  icon: IconType;
  proficiency?: number; // 0-100
  delay?: number;
}

export const SkillBadge = ({
  name,
  icon: Icon,
  proficiency,
  delay = 0
}: SkillBadgeProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay }}
      whileHover={{
        scale: 1.05,
        boxShadow: '0 0 25px rgba(59, 130, 246, 0.5)',
      }}
      className="relative group"
    >
      {/* Glassmorphism card */}
      <div className="relative backdrop-blur-sm bg-white/80 dark:bg-dark-800/50 border border-gray-200 dark:border-dark-700 rounded-xl p-4 transition-all duration-300 hover:border-primary-500/50">
        {/* Glow effect on hover */}
        <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-primary-500/0 via-primary-500/10 to-secondary-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <div className="relative flex flex-col items-center gap-3">
          {/* Icon */}
          <div className="text-3xl text-primary-400 group-hover:text-primary-300 transition-colors duration-300">
            <Icon />
          </div>

          {/* Name */}
          <span className="font-medium text-gray-900 dark:text-dark-100 text-sm text-center">
            {name}
          </span>

          {/* Optional proficiency bar */}
          {proficiency !== undefined && (
            <div className="w-full mt-1">
              <div className="h-1.5 bg-gray-200 dark:bg-dark-700 rounded-full overflow-hidden">
                <motion.div
                  className="h-full bg-gradient-to-r from-primary-500 to-secondary-500 rounded-full"
                  initial={{ width: 0 }}
                  whileInView={{ width: `${proficiency}%` }}
                  viewport={{ once: true }}
                  transition={{ duration: 1, delay: delay + 0.3 }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};
